module.exports = __webpack_public_path__ + "static/008-b50a30d70677be809b00e3a72c38e071.png";